// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"CustomUI_custom_select__2o66s","small":"CustomUI_small__2Vvlx","large":"CustomUI_large__3uPCU","custom_textfield":"CustomUI_custom_textfield__pEm8e"};